// src/components/Logo.jsx
import React from 'react';

const Logo = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <g>
      <path
        stroke="#5A67D8"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M25 40 C25 25, 40 25, 40 40 S55 55, 55 40"
      />
      <path
        stroke="#2D3748"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M75 60 C75 75, 60 75, 60 60 S45 45, 45 60"
      />
      <circle cx="40" cy="65" r="5" fill="#5A67D8" />
      <circle cx="60" cy="35" r="5" fill="#2D3748" />
    </g>
  </svg>
);

export default Logo;